import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CountryFlagComponent } from '@aw/shared/components/country-flag';
import { CountryPrefix } from '@aw/shared/constants';

@Component({
  standalone: true,
  selector: 'aw-country-prefix-select-option',
  templateUrl: 'country-prefix-select-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CountryFlagComponent, NgClass],
})
export class CountryPrefixSelectOptionComponent {
  @Input() item!: CountryPrefix;

  @Input() selected = false;
}
